<div class=" bg-white w-fit max-w-96 h-fit flex flex-col justify-center items-center p-6 rounded-lg space-y-6">
    <div class="flex flex-col items-center py-6 px-10 space-y-4">
        <app-loader></app-loader>
        <div class="font-medium">กำลังอัพเดตข้อมูล กรุณารอสักครู่</div>
    </div>
</div>